module.exports = __webpack_public_path__ + "static/sport/slide8.d338be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/slide8.png
// module id = PR/U
// module chunks = 0